import React, { useRef } from 'react'
import'./Herosection.css'

function Herosection() {
  return (
    <div className='hero'>
        <div className='nav'>
        <a href='Michael O Resume.pdf' download='Michael Michael o Resume.pdf'>
          <button  className='nav__button'>Resume</button>
         </a>           
        </div>  
                  <div className='hero__wrapper'>              
                  <div className='hero__header'>
                    <span>Hello, my name is</span>
                  </div>
                      <div className='hero__headerbtwn'>
                        <h1>Michael O. Akoolo</h1>
                        <h2>I build Amazing React Projects for Clients</h2>
                        <span>Iam a full-stack engineer specializing in creating MERN stack<br />
                              Front-end and Back-end jobs with exceptional experience. Currently<br/>
                              i'm focussed on building an online freelance experience to gain more<br />
                              expertise
                        </span>
                        
                      </div>
                      <div className='hero__button'>
                      <button href="mywork"className='div__button'>Check out my work!</button>
                      </div>
          </div>
    </div>
  )
}

export default Herosection